module.exports = __webpack_public_path__ + "static/media/whistle-dog-2024-dt-en.66949cd7.jpg";